/**
 * @file 404 Not Found Page
 */
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Frown } from "lucide-react";
import SEO from "../components/SEO";
import { Button } from "../ui";

export default function NotFound() {
  return (
    <div style={{ minHeight: "60dvh", display: "flex", alignItems: "center", justifyContent: "center", padding: "32px 20px" }}>
      <SEO title="Página no encontrada | Consultto" />
      <div style={{ textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center", gap: 12, maxWidth: 360 }}>
        <Frown size={64} style={{ color: "var(--ink-4)" }} />
        <h1 style={{ fontFamily: "var(--serif)", fontWeight: 500, fontSize: 48, letterSpacing: "-0.025em", color: "var(--ink)", margin: 0 }}>
          404
        </h1>
        <p style={{ color: "var(--ink-3)", margin: 0 }}>
          La página que buscas no existe o fue eliminada.
        </p>
        <Button asChild size="lg">
          <RouterLink to="/">Volver al inicio</RouterLink>
        </Button>
      </div>
    </div>
  );
}
